import AnimatedContent from '@/components/AnimatedContent.jsx';
import SplitText from '@/components/SplitText.jsx';
import { HotspotOverlayBadge } from './HotspotOverlayBadge.jsx';
import { HotspotOverlayCard } from './HotspotOverlayCard.jsx';

/** @see https://www.reactbits.dev/text-animations/split-text */
const SPLIT_TEXT_ANIM = {
  delay: 50,
  duration: 0.4,
  ease: 'power3.out',
  from: { opacity: 0, y: 40 },
  to: { opacity: 1, y: 0 },
  threshold: 0.1,
  rootMargin: '-100px',
  triggerOnMount: true,
};

/**
 * @param {{
 *   markerName: string;
 *   driver: import('../drivers.js').Driver;
 *   description: string;
 * }} props
 */
export function HotspotOverlay({ markerName, driver, description }) {
  return (
    <>
      <HotspotOverlayBadge text={markerName} splitTextAnim={SPLIT_TEXT_ANIM} />
      <HotspotOverlayCard>
        <div className="hotspot-overlay__hero">
          <AnimatedContent
            triggerOnMount
            distance={100}
            direction="vertical"
            reverse={false}
            duration={0.8}
            ease="power3.out"
            initialOpacity={0}
            animateOpacity
            scale={1}
            threshold={0.1}
            delay={0}
            className="hotspot-overlay__profile-anim"
          >
            <img
              className="hotspot-overlay__profile"
              src={driver.profileImage}
              alt={`${driver.firstName} ${driver.lastName}`}
            />
          </AnimatedContent>
          <div className="hotspot-overlay__info">
            <AnimatedContent
              triggerOnMount
              distance={100}
              direction="horizontal"
              reverse={false}
              duration={0.8}
              ease="power3.out"
              initialOpacity={0}
              animateOpacity
              scale={1}
              threshold={0.1}
              delay={0}
              className="hotspot-overlay__number-anim"
            >
              <div className="hotspot-overlay__number hotspot-overlay__number--placeholder">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect x="20" y="2" width="25.46" height="25.46" rx="4" transform="rotate(45 20 2)" fill="currentColor" fillOpacity="0.15" stroke="currentColor" strokeOpacity="0.3" strokeWidth="1.5"/>
                </svg>
              </div>
            </AnimatedContent>
            <div className="hotspot-overlay__names">
              <SplitText
                text={driver.firstName}
                tag="span"
                splitType="chars"
                textAlign="left"
                className="hotspot-overlay__first-name"
                startDelay={300}
                {...SPLIT_TEXT_ANIM}
              />
              <SplitText
                text={driver.lastName}
                tag="span"
                splitType="chars"
                textAlign="left"
                className="hotspot-overlay__last-name"
                startDelay={150}
                {...SPLIT_TEXT_ANIM}
              />
            </div>
          </div>
        </div>
        <div className="hotspot-overlay__quote">
          <SplitText
            text={description}
            tag="p"
            splitType="lines"
            textAlign="left"
            startDelay={600}
            duration={1}
            {...SPLIT_TEXT_ANIM}
          />
        </div>
      </HotspotOverlayCard>
    </>
  );
}
